<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<!------------ START TEMPLATE ------------>
<template>
  <div
    v-if="exibir == true"
    id="data-list-list-view"
    class="data-list-container"
  >
    <div
      class="sm:hidden bg-success fixed bottom-0 left-0 w-full text-center p-6 adicionaPropostaMobile"
      v-if="
        $can($actionsDefault.Escrita, subjectPermission) && decoded.consultor
      "
    >
      <div
        class="text-white"
        @click="novaProposta()"
        v-if="
          $can($actionsDefault.Escrita, subjectPermission) && decoded.consultor
        "
      >
        <feather-icon class="" icon="PlusCircleIcon" svgClasses="h-5 w-5" />
        <span class="ml-2">Adicionar nova Proposta</span>
      </div>
    </div>

    <ModalHistorico :dadosHistorico="dadosHistorico" />

    <div>
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between pt-4"
      >
        <div class="hidden sm:flex flex-wrap-reverse items-center">
          <div
            class="py-4 px-6 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between bg-success text-white"
            @click="novaProposta()"
            v-if="
              $can($actionsDefault.Escrita, subjectPermission) &&
              decoded.consultor
            "
          >
            <feather-icon icon="PlusCircleIcon" svgClasses="h-5 w-5" />
            <span class="ml-2">Adicionar nova Proposta</span>
          </div>
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ paginaAtual * itemsPerPage - (itemsPerPage - 1) }} -
              {{ itens.length }} de {{ qtdTotal }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <vs-card class="showMobile">
        <vs-pagination
          :max="screenWidth < 650 ? 5 : 9"
          v-if="qtdPaginas > 1"
          :total="qtdPaginas"
          v-model="paginaAtual"
        ></vs-pagination>
      </vs-card>

      <vs-card v-if="!qtdPaginas" class="flex justify-center p-4">
        <h5 class="mt-2">Nenhuma Proposta Encontrada</h5>
      </vs-card>

      <div v-for="item in itens" :key="item.id">
        <div class="relative pb-4 mb-6">
          <vs-card>
            <div class="vx-row">
              <div class="vx-col flex w-full justify-between">
                <div class="flex w-11/12 lg:w-full justify-between ml-2">
                  <div class="vx-col flex gap-1 mt-2 mb-4">
                    <vs-chip class="divIdProposta rounded" color="#078fcf">{{
                      item.idProposta
                    }}</vs-chip>
                    <vs-chip
                      v-if="item.tipoComplemento"
                      color="dark"
                      class="divIdProposta rounded"
                    >
                      Veículo + {{ toCapitalize(item.tipoComplemento) }}
                    </vs-chip>
                    <vs-chip
                      color="#078fcf"
                      class="divIdProposta rounded"
                      v-if="vistoria"
                    >
                      {{
                        item.tipoProposta === 'Adesão'
                          ? 'Contratação'
                          : item.tipoProposta
                      }}
                    </vs-chip>
                    <vs-chip
                      class="divIdProposta rounded"
                      v-if="!vistoria"
                      :color="getStatusColor(item.nomeStatus)"
                    >
                      {{ item.nomeStatus }}
                    </vs-chip>

                    <div class="divInfo mt-1">
                      {{ formataData(item.dataCotacao) }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="vx-col w-full lg:flex lg:justify-between ml-2">
                <div class="gap-3 mb-4 lg:w-full mr-2">
                  <div class="divSubTitle">
                    {{ item.dadosCliente.associado }}
                    <router-link
                      target="_blank"
                      :to="`/DetalheAssociado/${item.dadosCliente.idProspect}`"
                    >
                      <feather-icon
                        icon="ExternalLinkIcon"
                        svgClasses="h-4 w-4"
                      />
                    </router-link>
                  </div>
                  <div class="divInfo">{{ item.cpfcnpj }}</div>
                  <div class="divInfo">{{ item.email }}</div>
                  <div v-if="!item.celular" class="divInfo">
                    {{ item.telefone }}
                  </div>
                  <a
                    target="_blank"
                    :href="`https://wa.me/55${item.celular
                      .replace('(', '')
                      .replace(')', '')
                      .replace(' ', '')
                      .replace('-', '')}`"
                    v-else
                    class="divInfo cursor-pointer"
                  >
                    {{ item.celular }}
                    <vs-icon color="success" icon-pack="fa" icon="fa-whatsapp">
                    </vs-icon>
                  </a>
                </div>

                <div class="mb-4 lg:block flex gap-4 lg:w-full">
                  <p class="divTitle">DIVISÃO/REGIONAL</p>
                  <div class="divInfo">
                    {{ item.nome_divisao }}
                  </div>
                  <div class="divInfo">{{ item.nome_regional }}</div>
                </div>

                <div class="mb-4 lg:block flex gap-2 lg:w-full mr-2">
                  <p class="divTitle">{{ $t('Consultor').toUpperCase() }}</p>
                  <div class="divInfo">
                    {{ item.nomeVendedor }}
                  </div>
                </div>

                <div
                  v-if="!vistoria"
                  class="gap-2 mb-4 lg:block flex lg:w-full mr-2"
                >
                  <p class="divTitle">CIDADE/UF</p>
                  <div class="divInfo">
                    {{ item.cidade }} / {{ item.estado }}
                  </div>
                </div>

                <div
                  v-if="vistoria"
                  class="lg:block flex gap-2 mb-4 lg:w-full mr-2"
                >
                  <p class="divTitle">RESPONSÁVEL</p>
                  <div class="divInfo">
                    {{ item.nomeResponsavel }}
                  </div>
                </div>

                <div
                  v-if="vistoria"
                  class="lg:block flex gap-2 mb-4 lg:w-full mr-2"
                >
                  <p class="divTitle">RECUSAS</p>
                  <div class="divInfo">
                    {{ item.qtdRecusa ? item.qtdRecusa : 0 }}
                  </div>
                </div>

                <div class="dropdownAcoes">
                  <vs-dropdown
                    vs-trigger-click
                    class="flex cursor-pointer mr-2"
                  >
                    <div
                      class="rounded-full cursor-pointer"
                      style="background: #078fcf"
                    >
                      <vs-icon
                        round
                        class="m-1"
                        size="medium"
                        color="white"
                        icon="more_horiz"
                      ></vs-icon>
                    </div>

                    <vs-dropdown-menu style="width: 250px">
                      <vs-dropdown-item
                        v-if="
                          $can($actionsDefault.Escrita, subjectPermission) ||
                          (item.id_Status == 7 &&
                            $can('Aceitar Pré Análise', 'Vistorias'))
                        "
                        :to="`editarCotacao2/${item.idProposta}`"
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="success"
                            icon-pack="feather"
                            icon="icon-edit"
                          >
                          </vs-icon>
                          <span>Editar proposta</span>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item
                        divider
                        class="pt-2"
                        @click="openModal(item.idProposta)"
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="primary"
                            icon-pack="feather"
                            icon="icon-search"
                          >
                          </vs-icon>
                          <span>Detalhes da Proposta</span>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item
                        v-if="
                          item.id_Status == 4 &&
                          functions.verificaEmpresaBemProtege(item.id_empresa)
                        "
                        divider
                        class="pt-2"
                        target="_blank"
                        :to="`contratoAdesao/${item.chave}`"
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="warning"
                            icon-pack="feather"
                            icon="icon-file-text"
                          >
                          </vs-icon>
                          <span>Contrato</span>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item
                        v-if="
                          item.id_Status == 4 &&
                          functions.verificaEmpresaBemProtege(item.id_empresa)
                        "
                        divider
                        class="pt-2"
                        target="_blank"
                        :to="`laudoVistoria/${item.chave}`"
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="primary"
                            icon-pack="feather"
                            icon="icon-folder"
                          >
                          </vs-icon>
                          <span>Laudo de Vistoria</span>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item
                        v-if="
                          vistoria == true &&
                          (($can('Assumir Responsabilidade', 'Vistorias') &&
                            item.nomeResponsavel == null) ||
                            $can('Editar Responsável Vistoria', 'Vistorias'))
                        "
                        divider
                        class="pt-2"
                        @click="abrirModalResponsavelVistoria(item.idProposta)"
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="warning"
                            icon-pack="feather"
                            icon="icon-user"
                          >
                          </vs-icon>
                          <span>Assumir Responsabilidade pela Análise</span>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item
                        v-if="
                          ((vistoria == true ||
                            item.dataVistoria ||
                            item.nomeStatus == 'Aguardando Aprovação' ||
                            item.nomeStatus == 'Finalizada' ||
                            item.nomeStatus == 'Em Processo de Vistoria' ||
                            item.nomeStatus == 'Pendente') &&
                            $can('Visualizar Vistoria', subjectPermission)) ||
                          $can(
                            'Aprovar proposta sem vistoria',
                            subjectPermission,
                          )
                        "
                        divider
                        class="pt-2"
                        :to="`detalheVistoria/${item.idProposta}`"
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="dark"
                            icon-pack="feather"
                            icon="icon-camera"
                          >
                          </vs-icon>
                          <span>Detalhes da Vistoria</span>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item
                        divider
                        class="pt-2"
                        target="_blank"
                        :to="
                          item.idFrota && item.chaveMultiProposta
                            ? `multi-propostas/${item.chaveMultiProposta}`
                            : `proposta/${item.chave}?interno=true`
                        "
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="warning"
                            icon-pack="feather"
                            icon="icon-send"
                          >
                          </vs-icon>
                          <span>Link da Proposta</span>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item
                        v-if="
                          item.nomeStatus == 'Em Aberto' ||
                          decoded.id_usuario == 1151 ||
                          decoded.id_usuario == 1973
                        "
                        divider
                        class="pt-2"
                        target="_blank"
                        :href="returnLinkWhats(item)"
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="success"
                            icon-pack="fa"
                            icon="fa-whatsapp"
                          >
                          </vs-icon>
                          <span>Whatsapp</span>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item
                        v-if="
                          item.nomeStatus != 'Recusada' &&
                          item.nomeStatus != 'Finalizada' &&
                          $can('Recusar', subjectPermission)
                        "
                        divider
                        class="pt-2"
                        @click="openModalRecusa(item.idProposta)"
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="danger"
                            icon-pack="feather"
                            icon="icon-minus"
                          >
                          </vs-icon>
                          <span>Recusar Proposta</span>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item
                        divider
                        class="pt-2"
                        target="_blank"
                        :to="`DetalheAssociado/${item.id_prospect}?relacionamento=true`"
                      >
                        <div class="flex gap-3">
                          <vs-icon
                            color="#7149C6"
                            icon-pack="feather"
                            icon="icon-eye"
                          >
                          </vs-icon>
                          <span>Relacionamento</span>
                        </div>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
              <div v-if="vistoria" class="tagsInfo vx-col w-full">
                <div
                  @click="
                    openModalHistorico(
                      item.idProposta,
                      item.nomeStatus,
                      item.ultimaAlteracaoStatus || item.dataCotacao,
                    )
                  "
                  class="flex flex-wrap gap-1"
                >
                  <vs-chip
                    :color="getStatusColor(item.nomeStatus)"
                    class="divIdProposta rounded mb-4"
                  >
                    {{ item.nomeStatus }}
                  </vs-chip>
                  <vs-chip
                    v-if="
                      vistoria == true &&
                      (item.nomeStatus == 'Aguardando Aprovação' ||
                        item.nomeStatus == 'Pendente' ||
                        item.nomeStatus == 'Finalizada' ||
                        item.nomeStatus == 'Em Pré-Análise')
                    "
                    :color="
                      getStatusColorHoras(
                        item.nomeStatus,
                        item.ultimaAlteracaoStatus || item.dataCotacao,
                      )
                    "
                    class="divIdProposta rounded mb-4"
                  >
                    <feather-icon
                      icon="ClockIcon"
                      class="mr-2"
                      svgClasses="stroke-current w-6 h-6"
                    />

                    <span v-if="item.nomeStatus !== 'Em Pré-Análise'">{{
                      calculaQtddeDiasEnviada(
                        item.nomeStatus,
                        item.ultimaAlteracaoStatus || item.dataCotacao,
                      )
                    }}</span>
                    <span v-if="item.nomeStatus === 'Em Pré-Análise'"
                      >{{
                        calculaQtddeDiasEnviada(
                          item.nomeStatus,
                          item.ultimaAlteracaoStatus || item.dataCotacao,
                        )
                      }}
                      do total de 12h</span
                    >
                  </vs-chip>
                  <vs-chip
                    v-if="
                      item.qtdRecusa > 0 &&
                      vistoria == true &&
                      item.nomeStatus == 'Aguardando Aprovação'
                    "
                    color="#FF6347"
                    class="divIdProposta rounded mb-4"
                  >
                    <feather-icon
                      icon="AlertTriangleIcon"
                      class="mr-2"
                      svgClasses="stroke-current w-6 h-6"
                    />
                    Retorno de Pendência
                  </vs-chip>

                  <vs-chip
                    v-if="
                      item.nomeStatus == 'Finalizada' &&
                      item.sincronizacaoSga == false &&
                      item.dataSincronizacaoSga != null
                    "
                    class="divIdPropostarounded mb-4"
                    color="danger"
                    >Necessário Resync
                  </vs-chip>
                </div>
              </div>
              <transition name="slide">
                <div v-if="item.expandeDetalhes" class="vx-col w-full">
                  <div class="w-full flex justify-center mb-3">
                    <hr class="hrDetalhes mt-2" />
                  </div>
                  <div class="sm:flex gap-6 w-full mt-3">
                    <div class="flex gap-2 mb-2">
                      <vs-icon
                        :icon="iconeTipoVeiculo(item.codTipoVeiculo)"
                        size="small"
                        color="#374957"
                      ></vs-icon>
                      <div>
                        <p class="divSubTitle">Placa: {{ item.placa }}</p>
                        <p class="divInfo">Grupo: {{ item.nomeGrupo }}</p>
                      </div>
                    </div>

                    <div class="flex gap-2 mb-2">
                      <vs-icon
                        icon="description"
                        size="small"
                        color="#374957"
                      ></vs-icon>

                      <p class="divSubTitle">
                        {{ item.veiculoMarca }} {{ item.veiculoModelo }}
                      </p>
                    </div>

                    <div v-if="item.tipoComplemento" class="flex gap-2 mb-2">
                      <vs-icon
                        :icon="iconeTipoVeiculo(item.codTipoVeiculo)"
                        size="small"
                        color="#374957"
                      ></vs-icon>
                      <div>
                        <p class="divSubTitle">
                          Placa do {{ item.tipoComplemento }}:
                          {{ item.placaComplemento || 'Sem placa' }}
                        </p>

                        <p class="divInfo">
                          Grupo: {{ item.nomeGrupoComplemento }}
                        </p>
                      </div>
                    </div>

                    <div v-if="item.tipoComplemento" class="flex gap-2 mb-2">
                      <vs-icon
                        icon="description"
                        size="small"
                        color="#374957"
                      ></vs-icon>
                      <p class="divSubTitle">
                        {{ item.marcaComplemento }} -
                        {{ item.modeloComplemento }}
                      </p>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </vs-card>
          <div class="expandirCotacoes vx-col">
            <vs-button
              color="#E9E9E9"
              text-color="#374957"
              :icon="item.expandeDetalhes ? 'expand_less' : 'expand_more'"
              icon-after
              class="w-full buttonExpandirCotacoes z-0 text-base font-semibold"
              @click="item.expandeDetalhes = !item.expandeDetalhes"
              >{{ item.expandeDetalhes ? 'Recolher' : 'Expandir' }}</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <vs-card>
      <vs-pagination
        :max="screenWidth < 650 ? 5 : 9"
        v-if="qtdPaginas"
        :total="qtdPaginas"
        v-model="paginaAtual"
      ></vs-pagination>
    </vs-card>

    <vs-popup
      class="holamundo"
      :title="'Recusar Proposta'"
      :active.sync="popRecusa"
      @close="popRecusa = false"
    >
      <label for="" class="vs-select--label">Motivo de Recusa</label>
      <v-select
        :options="motivos"
        name="Motivo de Recusa"
        id="Motivo de Recusa"
        v-model="formRecusa.idMotivo"
        v-validate="{ required: true }"
        label="label"
        :state="validateState('Motivo de Recusa')"
        :class="validateClass('Motivo de Recusa')"
      ></v-select>

      <vs-textarea
        class="mb-2 my-5"
        placeholder="Insira uma observação sobre a Recusa"
        v-model="formRecusa.obsRecusa"
      />
      <vs-button
        @click="recusarProposta()"
        color="success"
        class="mb-2 my-5 ml-2"
      >
        <span>Salvar</span>
      </vs-button>
    </vs-popup>

    <!------------ START INFORMAÇÕES DO Proposta ------------>
    <vs-popup
      v-if="modalSelecionado != {}"
      class="holamundo"
      :title="'Detalhes Proposta'"
      :active.sync="popupActive"
      @close="closePop"
    >
      <table class="table table-bordered">
        <tr>
          <th class="uppercase">Código da Proposta</th>
          <td>{{ modalSelecionado.idProposta }}</td>
        </tr>
        <tr>
          <th class="uppercase">Tipo</th>
          <td>{{ modalSelecionado.tipoProposta }}</td>
        </tr>
        <tr>
          <th class="uppercase">Status</th>
          <td>{{ modalSelecionado.nomeStatus }}</td>
        </tr>
        <tr v-if="modalSelecionado.motivoRecusa">
          <th class="uppercase">Motivo Recusa</th>
          <td>{{ modalSelecionado.motivoRecusa }}</td>
        </tr>
        <tr v-if="modalSelecionado.obsRecusa">
          <th class="uppercase">Obs. Recusa</th>
          <td>{{ modalSelecionado.obsRecusa }}</td>
        </tr>
        <tr>
          <th class="uppercase">Data da Proposta</th>
          <td>{{ ajustaDataHoraUtc(modalSelecionado.createdAt) }}</td>
        </tr>
        <tr v-if="modalSelecionado.dataVistoria">
          <th class="uppercase">Data da Vistoria</th>
          <td>{{ formataData(modalSelecionado.dataVistoria) }}</td>
        </tr>
        <tr>
          <th class="uppercase">Origem</th>
          <td>{{ modalSelecionado.origem }}</td>
        </tr>
        <!-- <tr v-if="modalSelecionado.nomeOrigemLead">
          <th class="uppercase">Origem do Lead</th>
          <td>{{ modalSelecionado.nomeOrigemLead }}</td>
        </tr> -->
        <tr v-if="modalSelecionado.cotaTabela">
          <th class="uppercase">Cota Tabela</th>
          <td>{{ modalSelecionado.cotaTabela }}</td>
        </tr>
        <tr v-if="modalSelecionado.restricaoDescricao">
          <th class="uppercase">Motivo Recusa</th>
          <td class="bg-danger text-white p-2">
            {{ modalSelecionado.restricaoDescricao }}
          </td>
        </tr>
        <tr v-if="modalSelecionado.observacao">
          <th class="uppercase">Observação</th>
          <td>{{ modalSelecionado.observacao }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVendedor">
          <th class="uppercase">{{ $t('Consultor') }}</th>
          <td>
            {{ modalSelecionado.dadosVendedor.usuario }} / Divisão:
            {{ modalSelecionado.regional }} / Regional:
            {{ modalSelecionado.nomeDivisao }}
          </td>
        </tr>
        <tr v-if="modalSelecionado.cupom">
          <th class="uppercase">Cupom Utilizado</th>
          <td>
            {{ modalSelecionado.cupom }}
          </td>
        </tr>
      </table>
      <hr class="my-2" />
      <h5 class="my-2">Dados do Beneficiário</h5>
      <table class="table table-bordered" v-if="modalSelecionado.dadosCliente">
        <tr>
          <th class="uppercase">Nome</th>
          <td>{{ modalSelecionado.dadosCliente.associado }}</td>
        </tr>
        <tr>
          <th class="uppercase">Email</th>
          <td>{{ modalSelecionado.dadosCliente.email }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosCliente.telefone">
          <th class="uppercase">Telefone</th>
          <td>{{ modalSelecionado.dadosCliente.telefone }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosCliente.celular">
          <th class="uppercase">Celular</th>
          <td>{{ modalSelecionado.dadosCliente.celular }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosCliente.celularAdicional">
          <th class="uppercase">Celular Adicional</th>
          <td>{{ modalSelecionado.dadosCliente.celularAdicional }}</td>
        </tr>
        <tr>
          <th class="uppercase">Endereço</th>
          <td>
            {{ modalSelecionado.dadosCliente.cep }}
            <br />
            {{ modalSelecionado.dadosCliente.endereco }}
            {{ modalSelecionado.dadosCliente.numero }}
            {{ modalSelecionado.dadosCliente.complemento }}
            <br />
            {{ modalSelecionado.dadosCliente.bairro }}
            <br />
            {{ modalSelecionado.dadosCliente.cidade }} /
            {{ modalSelecionado.dadosCliente.estado }}
          </td>
        </tr>
        <tr>
          <th class="uppercase">Tipo</th>
          <td>{{ modalSelecionado.dadosCliente.tipo }}</td>
        </tr>
        <tr>
          <th class="uppercase">CPF/CNPJ</th>
          <td>{{ modalSelecionado.dadosCliente.cpf }}</td>
        </tr>
      </table>
      <hr class="my-2" />
      <h5 class="my-2">Dados do Veiculo</h5>
      <table class="table table-bordered" v-if="modalSelecionado.dadosVeiculo">
        <tr v-if="modalSelecionado.isZero">
          <th class="uppercase">Zero KM</th>
          <td class="bg-success text-white p-2">
            NF: {{ modalSelecionado.nf }}
            <br />
            Data:{{ formataDataUTC(modalSelecionado.dataNf) }}
            <br />
            valor: {{ modalSelecionado.valorNf | currency }}
          </td>
        </tr>
        <tr v-if="modalSelecionado.nomeGrupo">
          <th class="uppercase">Grupo</th>
          <td>{{ modalSelecionado.nomeGrupo }}</td>
        </tr>
        <tr v-if="modalSelecionado.nomeClassificacao">
          <th class="uppercase">Classificação</th>
          <td>{{ modalSelecionado.nomeClassificacao }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.veiculoMarca">
          <th class="uppercase">Marca</th>
          <td>{{ modalSelecionado.dadosVeiculo.veiculoMarca }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.veiculoModelo">
          <th class="uppercase">Modelo</th>
          <td>{{ modalSelecionado.dadosVeiculo.veiculoModelo }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.anoFabricacao">
          <th class="uppercase">Ano</th>
          <td>
            {{
              modalSelecionado.dadosVeiculo.anoFabricacao == '32000'
                ? '0Km'
                : `${modalSelecionado.dadosVeiculo.anoFabricacao} / ${modalSelecionado.dadosVeiculo.anoModelo}`
            }}
          </td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.placa">
          <th class="uppercase">Placa</th>
          <td>{{ modalSelecionado.dadosVeiculo.placa }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.tipoCambio">
          <th class="uppercase">Tipo de Câmbio</th>
          <td>{{ modalSelecionado.dadosVeiculo.tipoCambio }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.numeroMotor">
          <th class="uppercase">Número do Motor</th>
          <td>{{ modalSelecionado.dadosVeiculo.numeroMotor }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.renavam">
          <th class="uppercase">Renavam</th>
          <td>{{ modalSelecionado.dadosVeiculo.renavam }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.chassi">
          <th class="uppercase">Chassi</th>
          <td>{{ modalSelecionado.dadosVeiculo.chassi }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.combustivel">
          <th class="uppercase">Combustivel</th>
          <td>{{ modalSelecionado.dadosVeiculo.combustivel }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.cilindradas">
          <th class="uppercase">Cilindrada</th>
          <td>{{ modalSelecionado.dadosVeiculo.cilindradas }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.codigoFipe">
          <th class="uppercase">Codigo Fipe</th>
          <td>{{ modalSelecionado.dadosVeiculo.codigoFipe }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.cor">
          <th class="uppercase">Cor</th>
          <td>{{ modalSelecionado.dadosVeiculo.cor }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.estadoPneu">
          <th class="uppercase">Estado do Pneu</th>
          <td>{{ modalSelecionado.dadosVeiculo.estadoPneu }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.km">
          <th class="uppercase">km</th>
          <td>{{ modalSelecionado.dadosVeiculo.km }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.valorFipe">
          <th class="uppercase">Valor</th>
          <td>{{ modalSelecionado.dadosVeiculo.valorFipe | currency }}</td>
        </tr>
        <tr v-if="modalSelecionado.dadosVeiculo.valorCobertura">
          <th class="uppercase">Valor Cobertura</th>
          <td>{{ modalSelecionado.dadosVeiculo.valorCobertura | currency }}</td>
        </tr>
        <tr v-if="modalSelecionado.valorCotaParticipacao">
          <th class="uppercase">Valor da Franquia</th>
          <td>{{ modalSelecionado.valorCotaParticipacao }} %</td>
        </tr>
        <tr v-if="modalSelecionado.valorParticipacaoMinimo">
          <th class="uppercase">Valor Mínimo de Participação</th>
          <td>{{ modalSelecionado.valorParticipacaoMinimo | currency }}</td>
        </tr>
        <tr v-if="modalSelecionado.restricoes.length > 0">
          <th class="uppercase">Restrições</th>
          <td>
            <p v-for="item in modalSelecionado.restricoes" :key="item.id">
              {{ item.descricao }}
            </p>
          </td>
        </tr>
      </table>
      <hr class="my-2" />
      <h5 class="my-2">Produtos</h5>
      <table class="table table-bordered" v-if="modalSelecionado.produtos">
        <tr v-if="modalSelecionado.produtos.length > 0">
          <th class="uppercase">Produtos</th>
          <td>
            <p v-for="item in modalSelecionado.produtos" :key="item.id">
              {{ item.nomeProduto }}
              <span
                v-if="item.descontoConcedido > 0"
                :style="'text-decoration: line-through;'"
                class="mr-2"
                >{{ item.valor | currency }}</span
              >
              <span class="valorprod mr-2"
                >( {{ item.valorFinal | currency }}
                <span v-if="item.isMensal == true">/mês</span>)</span
              >
            </p>
          </td>
        </tr>
        <tr>
          <th class="uppercase">Valor Mensal</th>
          <td>{{ somaValorTotalMes(modalSelecionado.produtos) | currency }}</td>
        </tr>
        <tr v-if="modalSelecionado.valorComissaoAplicadaFinal">
          <th class="uppercase">Valor Comissão</th>
          <td>{{ modalSelecionado.valorComissaoAplicadaFinal | currency }}</td>
        </tr>
        <tr v-if="modalSelecionado.valorComissaoAplicadaFinal">
          <th class="uppercase">Valor Total Mensal</th>
          <td>
            {{
              (modalSelecionado.valorComissaoAplicadaFinal +
                somaValorTotalMes(modalSelecionado.produtos))
                | currency
            }}
          </td>
        </tr>
        <tr>
          <th class="uppercase">Valor Entrada</th>
          <td>{{ somaValorTotal(modalSelecionado.produtos) | currency }}</td>
        </tr>
      </table>

      <!-- dados agregados -->
      <hr
        v-if="modalSelecionado.agregado && modalSelecionado.agregados"
        class="mt-8"
      />
      <div v-if="modalSelecionado.agregado && modalSelecionado.agregados">
        <div
          v-for="(agregado, index) in modalSelecionado.agregados"
          :key="index"
        >
          <h5
            v-if="
              modalSelecionado.agregado && modalSelecionado.agregados.length > 0
            "
            class="my-6"
          >
            Agregado - {{ agregado.placa || agregado.chassi }} |
            {{ agregado.descricao }}
          </h5>
          <table
            class="table table-bordered"
            v-if="modalSelecionado.dadosVeiculo"
          >
            <tr v-if="agregado.nomeGrupo">
              <th class="uppercase">Grupo</th>
              <td>{{ agregado.nomeGrupo }}</td>
            </tr>
            <tr v-if="agregado.descricao">
              <th class="uppercase">Descrição</th>
              <td>{{ agregado.descricao }}</td>
            </tr>
            <tr v-if="agregado.marca">
              <th class="uppercase">Marca</th>
              <td>{{ agregado.marca }}</td>
            </tr>
            <tr v-if="agregado.modelo">
              <th class="uppercase">Modelo</th>
              <td>{{ agregado.modelo }}</td>
            </tr>

            <tr v-if="agregado.placa">
              <th class="uppercase">Placa</th>
              <td>{{ agregado.placa }}</td>
            </tr>
            <tr v-if="agregado.chassi">
              <th class="uppercase">Chassi</th>
              <td>{{ agregado.chassi }}</td>
            </tr>
            <tr v-if="agregado.valorCobertura">
              <th class="uppercase">Valor Cobertura</th>
              <td>
                {{ agregado.valorCobertura | currency }}
              </td>
            </tr>
            <tr v-if="agregado.porcentagemParticipacao">
              <th class="uppercase">Valor da Franquia</th>
              <td>{{ agregado.porcentagemParticipacao }} %</td>
            </tr>
            <tr v-if="agregado.valorMinimoParticipacao">
              <th class="uppercase">Valor Mínimo de Participação</th>
              <td>{{ agregado.valorMinimoParticipacao | currency }}</td>
            </tr>
          </table>
          <hr class="my-2" />
          <h5 class="my-2">Produtos</h5>
          <table class="table table-bordered" v-if="agregado.produtosAgregado">
            <tr v-if="agregado.produtosAgregado.length > 0">
              <th class="uppercase">Produtos</th>
              <td>
                <p
                  v-for="item in agregado.produtosAgregado"
                  :key="item.idProduto"
                >
                  {{ item.nomeProduto }}
                  <span
                    v-if="item.descontoConcedido > 0"
                    :style="'text-decoration: line-through;'"
                    class="mr-2"
                    >{{ item.valor | currency }}</span
                  >
                  <span class="valorprod mr-2"
                    >( {{ item.valorFinal | currency }}
                    <span v-if="item.isMensal == true">/mês</span>)</span
                  >
                </p>
              </td>
            </tr>
            <tr>
              <th class="uppercase">Valor Mensal</th>
              <td>
                {{ somaValorTotalMes(agregado.produtosAgregado) | currency }}
              </td>
            </tr>
            <tr v-if="modalSelecionado.valorComissaoAplicadaFinal">
              <th class="uppercase">Valor Comissão</th>
              <td>
                {{ agregado.valorComissaoAplicadaFinal | currency }}
              </td>
            </tr>
            <tr v-if="modalSelecionado.valorComissaoAplicadaFinal">
              <th class="uppercase">Valor Total Mensal</th>
              <td>
                {{
                  (agregado.valorComissaoAplicadaFinal +
                    somaValorTotalMes(agregado.produtosAgregado))
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <th class="uppercase">Valor à Vista</th>
              <td>
                {{ somaValorTotal(agregado.produtosAgregado) | currency }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- dados implementos -->
      <hr
        v-if="modalSelecionado.implemento && modalSelecionado.implementos"
        class="mt-8"
      />
      <div v-if="modalSelecionado.implemento && modalSelecionado.implementos">
        <div
          v-for="(implemento, index) in modalSelecionado.implementos"
          :key="index"
        >
          <h5
            v-if="
              modalSelecionado.implemento &&
              modalSelecionado.implementos.length > 0
            "
            class="my-6"
          >
            Implemento -
            {{ implemento.placa || implemento.chassi || '' }}
            {{ implemento.descricao }}
          </h5>
          <table
            class="table table-bordered"
            v-if="modalSelecionado.dadosVeiculo"
          >
            <tr v-if="implemento.nomeGrupo">
              <th class="uppercase">Grupo</th>
              <td>{{ implemento.nomeGrupo }}</td>
            </tr>
            <tr v-if="implemento.descricao">
              <th class="uppercase">Descrição</th>
              <td>{{ implemento.descricao }}</td>
            </tr>
            <tr v-if="implemento.marca">
              <th class="uppercase">Marca</th>
              <td>{{ implemento.marca }}</td>
            </tr>
            <tr v-if="implemento.modelo">
              <th class="uppercase">Modelo</th>
              <td>{{ implemento.modelo }}</td>
            </tr>

            <tr v-if="implemento.placa">
              <th class="uppercase">Placa</th>
              <td>{{ implemento.placa }}</td>
            </tr>
            <tr v-if="implemento.chassi">
              <th class="uppercase">Chassi</th>
              <td>{{ implemento.chassi }}</td>
            </tr>
            <tr v-if="implemento.valorCobertura">
              <th class="uppercase">Valor Cobertura</th>
              <td>
                {{ implemento.valorCobertura | currency }}
              </td>
            </tr>
            <tr v-if="implemento.porcentagemParticipacao">
              <th class="uppercase">Valor da Franquia</th>
              <td>{{ implemento.porcentagemParticipacao }} %</td>
            </tr>
            <tr v-if="implemento.valorMinimoParticipacao">
              <th class="uppercase">Valor Mínimo de Participação</th>
              <td>{{ implemento.valorMinimoParticipacao | currency }}</td>
            </tr>
          </table>
          <hr />
        </div>
      </div>
    </vs-popup>

    <div
      class="tooltip vue-tooltip-theme"
      role="tooltip"
      id="tooltip_i49mvvi0bs"
      aria-hidden="true"
      x-placement="top"
      style="
        position: absolute;
        will-change: transform;
        top: 0px;
        left: 0px;
        transform: translate3d(1492px, 433px, 0px);
        display: none;
      "
    >
      <div class="tooltip-arrow" style="left: 0px"></div>
      <div class="tooltip-inner">Detalhes da Proposta</div>
    </div>

    <!-- modal assumir vistoria -->
    <div class="centerx">
      <vs-popup
        :fullscreen="true"
        title="Responsavel pela análise de Cadastro"
        @close="
          (modalResponsavelVistoria = false),
            (consultorAnaliseSelecionado = null)
        "
        :active.sync="modalResponsavelVistoria"
      >
        <div class="vx-row">
          <div class="mx-auto" style="padding: 12.5rem 1.25rem 25rem 1.25rem">
            <div class="vx-col w-full">
              <div v-if="$can('Editar Responsável Vistoria', 'Vistorias')">
                <p class="mb-5">
                  Selecione o responsável pela vistoria. Apenas o responsável
                  poderá aprovar ou reprovar a vistoria e as fotos. Clique em
                  sim para confirmar.
                </p>
                <span>{{ $t('Consultor') }}</span>
                <v-select
                  :options="colaboradoresCadastro"
                  name="Responsavel pela análise de Cadastro"
                  label="label"
                  id="idUsuarioResponsavelCadastro"
                  v-model="consultorAnaliseSelecionado"
                  class="select-large w-full"
                  :reduce="(item) => item.id"
                  v-validate="{ required: true }"
                  :state="validateState('Responsavel pela análise de Cadastro')"
                  :danger="
                    validateClass('Responsavel pela análise de Cadastro')
                  "
                ></v-select>
              </div>
              <div v-else>
                <p class="mb-5">
                  Esta ação fará com que você se torne o responsável pela
                  vistoria dessa cotação. Apenas você poderá aprovar ou reprovar
                  a vistoria e as fotos da vistoria. Quer continuar?
                </p>
              </div>
            </div>
            <div class="vx-col w-full text-right">
              <vs-button
                @click="
                  (modalResponsavelVistoria = false),
                    (consultorAnaliseSelecionado = null)
                "
                type="gradient"
                color="success"
                class="mt-5"
                style="margin-right: 5px"
              >
                <feather-icon
                  class="text-white"
                  icon="CheckIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
                Não
              </vs-button>
              <vs-button
                @click="tornarResponsavelVistoria()"
                type="gradient"
                color="success"
                class="mt-5"
              >
                <feather-icon
                  class="text-white"
                  icon="CheckIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
                Sim
              </vs-button>
            </div>
          </div>
        </div>
      </vs-popup>
    </div>
    <!------------ END INFORMAÇÕES DO Proposta ------------>
  </div>
</template>

<script>
import AddNewDataSidebar from './../Includes/SideBar';
import service from '../../services';
import moment from 'moment';
import vSelect from 'vue-select';
import jwt from 'jsonwebtoken';
import ModalHistorico from '../modais/ModalHistorico.vue';
import functions from '../../utils/functions';
import { decryptData } from '../../services/decryptData';

export default {
  components: {
    AddNewDataSidebar,
    vSelect,
    ModalHistorico,
  },
  props: [
    'filtro',
    'realizaFiltro',
    'vistoria',
    'subjectPermission',
    'propColaboradoresCadastro',
  ],
  watch: {
    realizaFiltro: function (newValue) {
      if (newValue == true) {
        this.buscaDados();
        this.$emit('filtroOk', true);
      }
    },
    paginaAtual: function () {
      this.buscaDados();
    },
    itemsPerPage: function () {
      this.buscaDados();
    },
    propColaboradoresCadastro: function (value) {
      if (value) {
        this.colaboradoresCadastro = value;

        // trata quando o usuário atual não vir na lista de colaboradores
        // const _colaboradoresCadastro = this.colaboradoresCadastro.reduce(
        //   (acc, item) => {
        //     if (item.id === null) item.label = this.nomeUsuario;
        //     acc.push(item);
        //     return acc;
        //   },
        //   [],
        // );

        // this.colaboradoresCadastro = _colaboradoresCadastro;
      }
    },
  },
  data() {
    return {
      functions: functions,
      colaboradoresCadastro: [],
      modalResponsavelVistoria: false,
      chave: 0,
      isAdmin: false,
      idEmpresa: null,
      dadosSideBar: {},
      motivos: [],
      formRecusa: {
        idProposta: null,
        obsRecusa: null,
        idMotivoRecusa: null,
      },
      controllerGeral: 'Proposta',
      formSideBar: 'Proposta',
      entidade: 'Proposta',
      titleSideBar: 'Adicionar Proposta',
      popupActive: false,
      popRecusa: false,
      modalSelecionado: {},
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 5,
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
      isMounted: false,
      addNewDataSidebar: false,
      exibir: false,
      regionais: [],
      regionaisUsuario: [],
      regionalDefault: [],
      usuarios_regionais: [],
      idRegionais: [],
      idProposta: null,
      nomeUsuario: '',
      consultorAnaliseSelecionado: null,
      id_usuario: null,
      dadosHistorico: {},
      isConsultor: null,
      screenWidth: null,
      decoded: null,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    returnLinkWhats(item) {
      let linkRelativo = window.location.origin;
      if (item.nome && item.celular ? item.celular : item.telefone) {
        var nome = item.nome.split(' ')[0];
        var celular = item.celular
          ? item.celular
          : item.telefone
              .replace('(', '')
              .replace(')', '')
              .replace(' ', '')
              .replace('-', '');
        var texto = `Olá ${nome}, tudo bem? A cotação da ${item.empresa} para proteger seu veículo foi gerada, você consegue aceita-la e fazer sua vistoria tudo por lá, acesse ${linkRelativo}/proposta/${item.chave}`;
        var textoEncode = encodeURI(texto);

        var link = '';
        //if (isBrowser == true)
        link = `https://api.whatsapp.com/send?phone=55${celular}&text=${textoEncode}`;
        //else link = `whatsapp://send?phone=55${celular}&text=${textoEncode}`;

        return link;
      } else return null;
    },
    verificaAdmin() {
      const token = localStorage.getItem('user-token');

      if (token) {
        const decoded = jwt.decode(token);
        if (decoded.nomePerfil == 'Super User') this.isAdmin = true;
      }

      const decoded = jwt.decode(token);

      this.id_usuario = decoded.id_usuario;
      this.nomeUsuario = decoded.nome;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref) ? 'has-error' : '';
      }
      return null;
    },
    novaProposta() {
      this.$router.push('novaProposta/Interno');
    },
    somaValorTotalMes(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal == true) total = total + element.valorFinal;
      });
      return total;
    },

    calculaQtddeDiasEnviada(status, date) {
      if (status === 'Finalizada')
        return moment(date).format('DD/MM/YYYY HH:mm:ss');

      const horas = moment().diff(date, 'hours');
      if (status == 'Em Pré-Análise') return horas + 'h';

      const ms = moment().diff(moment(date));
      return functions.formataMsParaData(ms);
    },

    getStatusColorHoras(status, date) {
      const a = moment();
      const horas = a.diff(date, 'hours');

      if (status === 'Finalizada') return 'dark';

      if (status === 'Em Pré-Análise') {
        if (horas < 4) return 'success';
        if (horas >= 4 && horas <= 8) return 'warning';
        if (horas > 8) return 'danger';
      }

      if (horas < 10) return 'success';
      if (horas >= 10 && horas <= 24) return 'warning';
      if (horas > 24) return 'danger';
    },
    somaValorTotal(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal != true) total = total + element.valorFinal;
      });
      return total;
    },
    closePop() {
      this.popupActive = false;
    },
    closeSideBar() {
      this.addNewDataSidebar = false;
      this.chave++;
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY HH:mm');
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    async recusarProposta() {
      const formRecusarPropValido = await this.$validator.validate(
        'Motivo de Recusa',
      );

      if (formRecusarPropValido) {
        this.formRecusa.idMotivoRecusa = this.formRecusa.idMotivo.id;
        this.$vs.loading();
        service
          .post('Cotacao', 'RecusarProposta', this.formRecusa)
          .then(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Proposta Recusada com sucesso`,
              color: 'success',
            });
            this.popRecusa = false;
            this.buscaDados();
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: error,
              color: 'danger',
            });
          });
      }
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        // this.idEmpresa = this.decoded.id_empresa;
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    buscaDados() {
      this.selected = [];
      this.$vs.loading();
      var objSend = {};
      if (this.filtro) {
        objSend = { ...this.filtro };
        objSend.dataInicial = moment(this.filtro.dataInicial).format(
          'YYYY-MM-DD',
        );
        objSend.dataFinal = moment(this.filtro.dataFinal).format('YYYY-MM-DD');

        if (this.filtro.regional) {
          const regionaisFiltro = this.filtro.regional.map((item) => item.id);
          objSend.regional = regionaisFiltro;
        }

        if (this.filtro.divisao) {
          const divisoesFiltro = this.filtro.divisao.map((item) => item.id);
          objSend.divisao = divisoesFiltro;
        }
      } else {
        objSend.tipoData = 'Data Cadastro';
        objSend.dataInicial = moment().add(-1, 'days').format('YYYY-MM-DD');
        objSend.dataFinal = moment().format('YYYY-MM-DD');
        objSend.regional = this.idRegionais;
      }

      objSend.pagina = this.paginaAtual;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;
      objSend.isConsultor = this.isConsultor;

      if (this.filtro) {
        if (this.filtro.regional) {
          var regionaisFiltro = this.filtro.regional.map((item) => item.id);
          objSend.regional = regionaisFiltro;
        } else {
          //objSend.regional = this.idRegionais;
        }
      } else {
        objSend.regional = this.idRegionais;
      }

      if (this.vistoria == true) {
        objSend.orderBy = 'dataVistoria';
        objSend.vistoria = this.vistoria;

        if (this.filtro) {
          if (!this.filtro.status)
            objSend.status = [
              { id: 3, label: 'Aguardando Aprovação' },
              { id: 4, label: 'Finalizada' },
              { id: 5, label: 'Pendente' },
              { id: 6, label: 'Em Processo de Vistoria' },
              { id: 7, label: 'Em Pré-Análise' },
            ];
        } else {
          objSend.status = [
            { id: 3, label: 'Aguardando Aprovação' },
            { id: 7, label: 'Em Pré-Análise' },
          ];
          objSend.dataInicial = null;
        }
      }

      const _permissaoDistribuirVistoria = this.$can(
        'Editar Responsável Vistoria',
        'Vistorias',
      );

      objSend.permissaoDistribuirVistoria = _permissaoDistribuirVistoria
        ? true
        : false;

      if (objSend.tipoData == 'Data Finalização da Vistoria') {
        objSend.orderBy = ' hs.createdAt asc, hs.idStatus asc ';
      }

      service
        .post('Cotacao', 'listarCotacoesFiltro', objSend)
        .then((res) => {
          this.exibir = true;
          this.itens = [];
          this.qtdTotal = res.data.qtd;
          this.qtdPaginas = this.qtdTotal / this.itemsPerPage;

          if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
          this.qtdPaginas = parseInt(this.qtdPaginas);

          if (this.qtdTotal > 0) {
            res.data.cotacoes.forEach((element) => {
              element.expandeDetalhes = false;
              this.itens.push(this.formataTransacao(element));
            });
          }

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscaRegionais() {
      this.$vs.loading();
      service
        .getAll(
          'Usuario',
          {},
          `list/${this.idEmpresa}?idUsuario=${this.id_usuario}`,
        )
        .then((res) => {
          this.$vs.loading.close();
          res.data.forEach((element) => {
            if (element.idUsuario == this.id_usuario) {
              if (element.usuarios_regionais.length > 0) {
                this.usuarios_regionais = element.usuarios_regionais;
                this.usuarios_regionais.forEach((elementSel) => {
                  this.regionaisUsuario.push({
                    id: elementSel.id_regional,
                    label: elementSel.nome,
                  });
                });
                this.regionais = this.regionaisUsuario.concat(
                  this.regionalDefault,
                );
                this.idRegionais = this.regionais.map((item) => item.id);
              } else {
                var usuarios_regionais = element.Usuarios_Regional;
                this.regionais.push({
                  id: usuarios_regionais.idRegional,
                  label: usuarios_regionais.nome,
                });
                this.idRegionais = this.regionais.map((item) => item.id);
              }
            }
          });
          this.buscaDados();
        });
    },
    buscaDadosRegionalDefault(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            if (element[campoPK] == this.decoded.id_regional) {
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
            }
          });
        });
    },
    formataTransacao(item) {
      item.idProposta = item.id_proposta;
      item.dadosVeiculo = {
        veiculoMarca: item.veiculoMarca,
        veiculoModelo: item.veiculoModelo,
        anoModelo: item.anoModelo,
        anoFabricacao: item.anoFabricacao,
        combustivel: item.combustivel,
        placa: item.placa,
        cilindradas: item.cilindradas,
        cor: item.cor,
        renavam: item.renavam,
        km: item.km,
        chassi: item.chassi,
        restricao: item.restricao,
        restricaoDescricao: item.restricaoDescricao,
        codigoFipe: item.codigoFipe,
        estadoPneu: item.estadoPneu,
        codTipoVeiculo: item.codTipoVeiculo,
        codigoMarca: item.codigoMarca,
        codigoModelo: item.codigoModelo,
        resultadoFipe: item.resultadoFipe,
        valorFipe: item.valorFipe,
        valorCobertura: item.valorCobertura,
        qtdPortas: item.qtdPortas,
        anoExercicioDut: item.anoExercicioDut,
      };
      item.dadosCliente = {
        idProspect: item.id_prospect,
        associado: item.nome,
        email: item.email,
        cpf: item.cpf,
        telefone: item.telefone,
        cidade: item.cidade,
        estado: item.estado,
        tipo: item.tipo,
        endereco: item.endereco,
        cep: item.cep,
        bairro: item.bairro,
        numero: item.numero,
        complemento: item.complemento,
        dataNascimento: moment(item.dataNascimento).format('DD/MM/YYYY'),
        rg_ie: item.rg_ie,
        cnh: item.cnh,
        catCnh: item.catCnh,
        representanteLegal: item.representanteLegal,
        cpfRepresentante: item.cpfRepresentante,
        dataVencimentoCnh: moment(item.dataVencimentoCnh).format('DD/MM/YYYY'),
        nomeOrigemLead: item.nomeOrigemLead,
      };
      return item;
    },
    openSideBar(dados) {
      dados.idProposta == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    openModal(cod) {
      this.$vs.loading();
      this.popupActive = true;
      if (cod)
        service
          .post('Cotacao', 'listarCotacoes', { idProposta: cod })
          .then((res) => {
            this.modalSelecionado = res.data[0];
            this.$vs.loading.close();
          });
    },
    openModalRecusa(cod) {
      this.formRecusa = {
        idProposta: cod,
        obsRecusa: null,
        idMotivoRecusa: null,
      };
      this.popRecusa = true;
    },

    openModalHistorico(id, nomeStatus, data) {
      this.dadosHistorico = {
        id: id,
        nomeStatus: nomeStatus,
        data: data,
      };
    },

    concluido() {
      this.chave++;
      this.buscaDados();
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
    getStatusColor(data) {
      return functions.getStatusColor(data);
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
    abrirModalResponsavelVistoria(id) {
      this.idProposta = id;
      this.modalResponsavelVistoria = true;
    },
    tornarResponsavelVistoria() {
      const idUsuarioResponsavelVistoria =
        this.consultorAnaliseSelecionado || this.id_usuario;

      const form = {
        idEmpresa: this.idEmpresa,
        idProposta: this.idProposta,
        idUsuarioResponsavelVistoria,
      };

      this.$vs.loading();
      service
        .post('Cotacao', 'atualizaResponsavelVistoria', form)
        .then((res) => {
          this.updateNomeResponsavelVistoria(res);

          this.modalResponsavelVistoria = false;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });

          this.abrirModalResponsavelVistoria = false;
          this.$vs.loading.close();
        });
    },
    updateNomeResponsavelVistoria(dados) {
      const { idProposta, idUsuarioResponsavelVistoria } = dados.data;

      const { label: nomeResponsavel } = this.colaboradoresCadastro.find(
        (colaborador) => colaborador.id == idUsuarioResponsavelVistoria,
      );

      this.itens.forEach((vistoria) => {
        if (vistoria.id_proposta == idProposta) {
          vistoria.nomeResponsavel = nomeResponsavel;
        }
      });
    },
    verificarResponsavelVistoria(idResponsavel) {
      return (
        this.$can('Assumir Responsabilidade', 'Vistorias') &&
        this.id_usuario === idResponsavel
      );
    },
    usuarioPodeAcessarVistoria(vistoria) {
      const podeAcessarVistoria =
        this.$can(
          'Assumir Responsabilidade',
          'Vistorias' || vistoria.idUsuarioResponsavelVistoria,
        ) ||
        (!vistoria.idUsuarioResponsavelVistoria &&
          this.$can('Assumir Responsabilidade', 'Vistorias')) ||
        this.$can(this.$actionsDefault.Escrita, this.subjectPermission);

      return podeAcessarVistoria;
    },
    ajustaDataHoraUtc(data) {
      return moment.utc(data).local().format('DD/MM/YYYY HH:mm');
    },
    obterDadosUsuario() {
      this.$vs.loading();
      service
        .post('Usuario', 'buscarUsuario', {
          idEmpresa: this.idEmpresa,
          idUsuario: this.id_usuario,
        })
        .then((res) => {
          const [dadosConsultor] = res.data;
          this.isConsultor = dadosConsultor.consultor;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    iconeTipoVeiculo(item) {
      if (item == 3) return 'local_shipping';
      if (item == 1) return 'directions_car';
      if (item == 2) return 'two_wheeler';
    },
    toCapitalize(str) {
      return str.replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });
    },
  },
  created() {
    this.getDecoded();
    this.verificaAdmin();
    this.idEmpresa = localStorage.getItem('idEmpresa');
  },
  mounted() {
    this.buscaDadosSelects(
      'domMotivoRecusaProposta',
      'motivos',
      'nomeMotivo',
      'idMotivo',
    );
    this.obterDadosUsuario();
    this.buscaRegionais('regionais', 'regionais', 'nome', 'idRegional');
    this.buscaDadosRegionalDefault(
      'regionais',
      'regionalDefault',
      'nome',
      'idRegional',
    );
    this.isMounted = true;
    this.screenWidth = window.innerWidth;
  },
};
</script>
<!------------ END SCRIPT ------------>

<style scoped src="../../assets/css/listCard.css"></style>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
  @media screen and (max-width: 768px) {
    .con-vs-popup {
      background-color: red;
      position: fixed;
    }
  }
}
.vs-button.includeIcon {
  float: left;
  margin-right: 5px;
}

.vs-chip-bg-pink {
  background-color: rgb(255, 68, 0);
}

.vs-chip-bg-blue {
  background-color: navy;
}
@media screen and (max-width: 768px) {
  .vue-back-to-top {
    margin-bottom: 35px;
  }
}

.divSubTitle {
  text-transform: uppercase;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
}
</style>

<!------------ END STYLE ------------>
<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
</style>
